module.exports = {
  "FoodB_manager_Kwwl_Cjll": "From day 8 to the end of the event, invest {{amount1}}–{{amount2}} and get a {{rate1}} platform reward.",
  "FoodB_manager_jhXU_ptlV": "The total number of times your ad was clicked",
  "FoodB_manager_OKSu_qWyl": "Editing is not allowed during the reward period and will be available after the event ends on {{end_data}}",
  "FoodB_images_tgoc_AhLQ": "Available",
  "FoodB_Overview_AasD_LvfW": "View More",
  "FoodB_manager_sgsH_EpiM": "day",
  "FoodB_manager_HqjV_CxOA": "Your budget doesn't meet the promotion requirements. Add budget to get promotion rewards",
  "FoodB_manager_ntwn_wBNk": "Ad Impressions",
  "FoodB_images_qpuG_DTcO": "Bad Image",
  "FoodB_manager_aCSR_lQaQ": "week",
  "FoodB_modification_Confirmation_ehVU": "OK",
  "FoodB_guidance_ympr_VDEB": "15% Off",
  "FoodB_V_Cancel_ELKJ": "Cancel",
  "FoodB_ads_PRAv_IxKG": "This is the total amount you’ve spent on this ad",
  "FoodB_manager_BMOX_RrUm": "Free for the First 7 Days",
  "FoodB_0526_ZwcV_xubO": "Complete Delivery",
  "FoodB_images_zcVM_dgvs": "No Image",
  "FoodB_0526_Ugoi_wHIL": "I have arrived at the location",
  "FoodB_202403_iElx_PrgH": "Permissions are required to access photo album. Please enable permissions, then try again",
  "FoodB_IOS_bkpb_pDAZ": "Marked as Unavailable",
  "FoodB_0526_ALSJ_vOIv": "Verify and Continue",
  "FoodB_ads_iUsb_wdEa": "Place an Ad",
  "FoodB_ads_JKaI_zpdU": "Unable to restart",
  "FoodB_optimization_lHJe_wjVZ": "{{num}} sold per month",
  "FoodB_structure_Next_step_GKKZ": "Next",
  "FoodB_202403_tIbT_QIhv": "Downloaded successfully",
  "FoodB_structure_If_the_qaXe": "If this item is a required part of any of the following items, Marking it unavailable will also make the other items unavailable.",
  "FoodB_edit_iIzf_VxWT": "Modifier Group Price",
  "FoodB_ads_Vuno_mXMy": "Pause",
  "FoodB_0526_xxjK_BrKm": "Verify Customer Confirmation Code",
  "FoodB_IOS_UOug_fSFt": "Collapse",
  "FoodB_manager_ZQKX_FOdY": "Free from today until {{trail_end_date}}",
  "FoodB_202507_Mmtm_bVsd": "Verification Code",
  "FoodB_ads_wEEv_oKzi": "Sales from Ads",
  "FoodB_manager_cfaa_kvuC": "Ad Impressions",
  "FoodB_ads_AbgR_WCms": "ROI",
  "FoodB_structure_The_group_yaQn": "The {{group_name}} modifier group is incomplete and cannot be uploaded. Please edit it and try again.",
  "FoodB_ads_fbjh_KkrE": "{{amount}} (Shared by all stores placing an ad)",
  "FoodB_b_Merchant_activities_AOMe": "Event Promotions",
  "FoodB_ads_kQlR_vLwo": "FAQ",
  "FoodB_edit_Kpjr_ClVJ": "Submit Changes",
  "FoodB_event_gnlU_HgeW": "Platform Rewards",
  "FoodB_signup_Rpjk_VExr": "Please check the box to accept the agreement",
  "FoodB_structure_Only_the_TlfX": "Mark this item unavailable only",
  "FoodB_manager_kgoO_KDWx": "Ad Orders",
  "FoodB_images_hyZS_lUdA": "Sales ▲",
  "Gattaran_System_stOW_oOzc": "Edit",
  "FoodB_202507_zUrC_RTLN": "Verification code cannot be empty",
  "FoodB_guidance_qLuz_cdFT": "Combos with discounts of 15% or more are eligible for inclusion in event promotions",
  "FoodB_0526_pago_jZCL": "Back",
  "FoodB_202412_AFEo_IMDT": "View",
  "FoodB_images_Odmy_EpkO": "Duplicate",
  "FoodB_notification_hZjl_FphL": "Your item name or description contains invalid words. Please check and try again.",
  "FoodB_202507_VtFw_lWoZ": "Verification code must be 6 digits",
  "FoodB_0526_CJIS_cGuT": "Store Delivery",
  "FoodB_end_wXDp_EzMh": "This field cannot be blank",
  "FoodB_Notification_cXDd_hXys": "Please Confirm",
  "FoodB_structure_There_are_IFaR": "More than one item has the same name. Please choose which item(s) to mark unavailable.",
  "FoodB_ads_eLJV_rpQs": "Restarted successfully",
  "FoodB_images_SJsQ_RTPC": "Default",
  "FoodB_202507_Kvbw_JjQU": "The invitation has expired. Please contact the store to obtain a new one",
  "FoodB_ads_LYLE_IJlq": "Ads Terms and Conditions",
  "FoodB_ads_JrZk_DAPd": "Create My Ad Plan",
  "FoodB_end_tShf_yvRL": "Please enter",
  "soda-b-web-i18n---必选": "Required",
  "FoodB_202507_pyLz_EIhG": "Verify and Continue",
  "FoodB_raise_GzoV_LxqP": "The price of one or more items couldn’t be changed. Please view details in the {{sys}} app.",
  "FoodB_end_jDIn_MChP": "Store Name",
  "FoodB_IOS_aPdf_nqLr": "Image Status",
  "FoodB_ads_dOkB_VPYp": "Stores for Ad Placement",
  "FoodB_Subscribe202412_zlrO_JCcA": "Attention",
  "FoodB_20240530_DIPS_Umqk": "Got It",
  "FoodB_Refund_VgKI_KAdX": "Item Name",
  "FoodB_structure_Remove_items_mzeF": "Mark all items with the same name (including subitems) unavailable",
  "FoodB_20220201_Confirmation_uFDW": "Confirm",
  "FoodB_0526_CWJT_tJDS": "When you meet the customer and hand over the order, ask them to provide a {{number4}}-digit verification code to confirm delivery.",
  "FoodB_manager_dbWL_uoLT": "The total number of times your ad was viewed",
  "FoodB_202507_AaJV_ONrK": "Download",
  "FoodB_202507_eldX_PSOm": "Resend",
  "FoodB_examination_RLMB_cTnU": "This item can’t be sold because its price is higher than the dine-in or other platform menu price(s). Please edit the item and modifier prices to be lower than the dine-in or other platform price(s), then mark the item as available again.",
  "FoodB_images_elYf_pCKJ": "Add",
  "FoodB_manager_KMon_Ucmi": "Up to {{{max_rate}}} Reward afterwards",
  "FoodB_manager_Pmbs_CYnh": "Participate in the event to receive a total of {{amount}} days of ad rewards. The first 7 days of advertising for your store are free",
  "FoodB_examination_jQot_WFxD": "Higher-Priced Item(s) Temporarily Removed",
  "FoodB_dishes_golj_IhqE": "This is a prohibited higher-priced item. Please adjust the price below the controlled price before marking it as available.",
  "FoodB_lines__item_gLep": "Unable to toggle availability for {{item}}. Reason:",
  "FoodB_ads_kkCY_VhnR": "Ad Details",
  "FoodB_0526_YWxv_qCMp": "Verify Order Locator Code",
  "FoodB_diagnosis_Add_the_ROcc": "Please specify how many people the combo is for",
  "FoodB_images_NRvd_CfNM": "Item Placement",
  "FoodB_images_kqnL_zpUk": "High-quality images can attract more orders.",
  "FoodB_manager_rzAQ_djgI": "From {{start_data}} to {{end_data}}, the platform covers {{p_budget}}/day and the store covers {{b_budget}}/day",
  "FoodB_manager_HaIz_XbUw": "You can view the ad revenue and more info on the Ad Details page",
  "FoodB_IOS_uqRa_ZgjI": "Marked as Available",
  "FoodB_manager_SKhT_KcPn": "Ad Budget",
  "FoodB_structure_This_item_Kjzb": "This item is in the following item modifier groups. Marking this item unavailable will also make it unavailable from the following modifier groups.",
  "FoodB_0526_obJO_XULq": "Step {{number1}}",
  "FoodB_manager_ZTpO_CxTr": "From today to {{end_data}}, the platform covers {{p_budget}}/week and the store covers {{b_budget}}/week",
  "FoodB_IOS_GAPD_nKPg": "Sale Status",
  "FoodB_images_Ifqh_ZbIZ": "All",
  "FoodB_end_btsz_MEkI": "Action Log",
  "FoodB_ads_GmKW_brRz": "This is the total sales generated by customers who placed an order within 7 days of seeing your ad",
  "FoodB_202403_GUuf_Hxvh": "DiDi Your Business",
  "FoodB_edit_FUgf_iAPR": "System error. Please try again.",
  "FoodB_images_Ruvq_UOGP": "Sales ▼",
  "FoodB_ads_hsyI_CluZ": "Ad Expenses",
  "FoodB_images_sDvo_WhBT": "Items without an image or with a duplicate image will not be eligible to participate in the promotion(s) shown below, which may affect the visibility of items.",
  "FoodB_edit_EauY_eVbs": "Prices of items in combos or promotions cannot be changed",
  "FoodB_ads_EUKq_wQqg": "Custom",
  "FoodB_3_Meij_rAcc": "No results found",
  "FoodB_manager_jDsw_neeZ": "Total ad budget after reward is {{total_amount}} per day",
  "FoodB_manager_PNYI_bdhw": "Please tap {at the top left of the page} to return to the list",
  "FoodB_manager_QWyb_fTPV": "After the reward ends on {{date}}, the ad budget will return to {{b_budget}} per week",
  "FoodB_diagnosis_Fill_in_izgd": "Please enter item description",
  "FoodB_manager_lrhZ_GgWG": "From {{start_data}} to {{end_data}}, the platform covers {{p_budget}}/week and the store covers {{b_budget}}/week",
  "FoodB_0526_Ohci_xuvI": "Business maintenance is in progress. Please stay tuned",
  "FoodB_0526_HUpD_BgTa": "You'll need the order locator code and customer confirmation code to confirm delivery.",
  "FoodB_manager_Vavg_QJRU": "From today to {{end_data}}, the platform covers {{p_budget}}/day and the store covers {{b_budget}}/day",
  "FoodB_ads_mCxj_GQTc": "Price (Price per Customer Click)",
  "FoodB_202311_BGpD_RoKX": "No more",
  "FoodB_Brazil_ajzJ_JuVl": "Under the brand franchise model, you do not have permission to perform this action. To proceed, please contact the DiDi Rep.",
  "FoodB_images_dCkE_owJP": "Duplicate images can reduce item visibility and result in fewer orders.",
  "FoodB_list_pycq_NFTr": "Show more",
  "FoodB_guidance_KjqW_ZOOL": "Discounts of 20% or more will help increase combo sales",
  "soda-b-web-i18n---可选": "Optional",
  "FoodB_202507_IeTZ_IsVt": "Invalid verification code. Please try again",
  "FoodB_list_RMhg_oxdJ": "Show less",
  "soda-b-web-i18n---请输入价格": "Enter Price",
  "FoodB_202507_TYLB_oGxx": "Become a Courier",
  "FoodB_manager_tfuO_mmOQ": "Invest {{amount3}} or more and get a {{rate3}} platform reward",
  "FoodB_ads_Mhsz_vxcz": "Pausing the ad will reduce your store's exposure, which may affect your orders.",
  "FoodB_0526_ItLx_NtXl": "The locator code entered is unrecognized. Please try again.",
  "FoodB_structure_Available_items_YZlI": "Add Item",
  "FoodB_manager_UQMz_EKvg": "Ad Clicks",
  "soda-b-web-i18n---请选择": "Please choose",
  "FoodB_structure_Confirmation_KdZD": "Confirm",
  "FoodB_202507_lSPc_azJu": "Hi! {{nick_name}} invites you to join {{store_name}}’s delivery team.",
  "FoodB_images_dkwU_DozC": "Remove",
  "FoodB_ads_xHIG_ssdt": "Target Group",
  "FoodB_ads_jnGH_TBtE": "Last updated: {{date}}",
  "FoodB_manager_dbGg_urLm": "Save Changes",
  "FoodB_ads_EuaQ_gUWs": "Weekly Budget",
  "FoodB_end_vWCI_Khdj": "Store ID",
  "FoodB_manager_cYvu_RUOJ": "The average daily spend over a week. The total weekly spend is capped at 7 times the daily budget.",
  "FoodB_menu_ezpD_HgJQ": "Delivery",
  "FoodB_manager_Zkso_jGUU": "Total ad budget after reward is {{total_amount}} per week",
  "FoodB_guidance_KPTM_jtce": "30% Off",
  "FoodB_Management_ETTC_atmq": "Attention",
  "FoodB_0526_LSWB_SqBa": "Locator",
  "FoodB_202507_KAIz_QuzG": "After downloading and installing the app, sign in with your verified mobile number to start delivering.",
  "FoodB_ads_SKdz_cIQv": "This is the return on sales you received for each {{amount}} spent on ad fees. This amount is calculated by dividing sales from the ad by the amount spent on the ad.",
  "FoodB_202403_Oupx_AERj": "Something went wrong. Please try downloading again",
  "FoodB_ads_fFZs_fhfw": "Are you sure you want to pause the ad?",
  "FoodB_one_Create_categories_NYkB": "Please create a category first",
  "FoodB_202507_pnqc_SLIH": "{{number}} verification successful!",
  "FoodB_0526_BiXD_Hdyk": "Step {{number2}}",
  "FoodB_ads_ohud_CQNg": "Restart",
  "FoodB_0526_wOWe_bCYw": "The customer confirmation code entered is unrecognized. Please try again.",
  "FoodB_manager_Taew_Vhya": "The total number of customers who viewed your ad",
  "FoodB_record_aMyR_GHwi": "Create",
  "FoodB_ads_TBRW_mcgC": "View",
  "FoodB_guidance_TyKs_OJEe": "Price cannot be 0",
  "Gattaran_app_wQyy_gBIH": "This feature is only available on the Store app and is currently not supported by {{app}}",
  "FoodB_ads_aBTZ_puGq": "Your Ad Plans",
  "FoodB_manager_pkmQ_slMM": "Registered Successfully",
  "FoodB_edit_OzpO_pQjy": "Edit Item",
  "FoodB_0526_RjfK_pdye": "Thank you for your delivery. The order has been confirmed as delivered.",
  "FoodB_structure_Dishes_off_DpDW": "Mark Item Unavailable",
  "FoodB_manager_bfcy_TuLs": "The maximum amount spent on advertising per week",
  "FoodB_ads_AUHA_UKTn": "Effective Status",
  "FoodB_images_mWCv_qwcI": "Unavailable",
  "FoodB_diagnosis_Package_prices_HhZb": "The combo price exceeds the maximum price",
  "FoodB_IOS_DuJM_XIww": "Expand",
  "FoodB_app_rJMe_JvWP": "Dine-In: {{DineInSpreadRatio}}% Spread",
  "FoodB_manager_WiiZ_fQTr": "Ad Clicks",
  "FoodB_202507_jFRj_JuzW": "Click for SMS",
  "FoodB_manager_tluR_ydNq": "Changed successfully",
  "FoodB_App__CeNy": "No recommended combos",
  "FoodB_202507_gJQz_KNsm": "Please verify your mobile number via SMS to help us confirm it belongs to you and is in active use:",
  "FoodB_menu_TLDI_rbsq": "Pickup",
  "Gattaran_System_FPHM_FNhp": "Ad Plans",
  "FoodB_manager_gCEg_QRci": "Restart ads before {{end_data}} to continue enjoying the platform reward",
  "FoodB_end_txmi_EUkK": "Created successfully",
  "FoodB_guidance_tIZK_FnCu": "20% Off",
  "FoodB_images_RTGc_aPGv": "Want to take photos of items? Try the camera feature!",
  "FoodB_end_EXUZ_AybF": "I have read and agree to",
  "FoodB_images_yEwu_BOgv": "View More",
  "FoodB_manager_YJWG_TGEr": "Invest {{amount2}} – {{amount3}} and get a {{rate2}} platform reward",
  "FoodB_examination_iFla_jDwD": "One or more items can’t be sold because their prices are higher than the dine-in price. Please check the {{sys}} app for details.",
  "FoodB_0526_WpAq_pLIl": "Have you arrived at the delivery location?",
  "FoodB_ads_zdck_cALt": "Data Performance",
  "FoodB_manager_OJaX_kWqN": "ROAS",
  "FoodB_manager_zkAd_zMmA": "The total number of customers who clicked on your ad",
  "FoodB_0526_rIpi_tOxQ": "The order locator code (an {{number3}}-digit number) can be found on the order receipt. It’s used to identify your order and can also serve as an extension number to contact the customer.",
  "FoodB_diagnosis_Store_Gallery_izRn": "Store Photos",
  "Gattaran_System_MdOu_YQGa": "Daily Budget",
  "FoodB_202507_oTId_ZJEY": "Download App",
  "FoodB_Packages_WVQT_trjL": "Modifier Name",
  "FoodB_edit_GGaD_NBFy": "Item Price",
  "FoodB_manager_cAxE_aMhz": "The number of orders placed by customers within 7 days of seeing the ad",
  "soda-b-web-i18n---请输入项目名称": "Enter Item Name",
  "FoodB_ads_WAjG_IoqX": "Ad",
  "FoodB_ads_mKyB_UXoD": "Promotion Rules",
  "FoodB_app_LKsL_pZNy": "Black: {{BlackSpreadRatio}}% Spread",
  "FoodB_manager_lvpx_Fggm": "Get a {{rate}} platform reward from day 8 until the end of the event",
  "FoodB_combination_dMkH_fHZW": "Amount must be between {{amount1}}–{{amount2}}",
  "Gattaran_System_wrVY_PjDQ": "Plan Name",
  "FoodB_manager_Adkb_bXXA": "After the reward ends on {{date}}, the ad budget will return to {{b_budget}} per day",
  "FoodB_guidance_LLRv_LmOz": "Combos with discounts of 30% or more will gain more exposure in the Super Special zone",
  "全部": "All",
  "搜索": "Search",
  "未搜索到相关菜品": "No search results",
  "暂无菜品": "No Menu Item",
  "搜索结果": "Search results",
  "菜品名称、加料": "Menu item name",
  "下架": "Mark unavailable",
  "上架": "Set as available",
  "菜品列表": "Item List"
}